export const ChevronDownSvg = () => {
    return (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.52855 11.1381C7.7889 11.3984 8.21101 11.3984 8.47136 11.1381L13.138 6.4714C13.3984 6.21105 13.3984 5.78894 13.138 5.52859C12.8777 5.26824 12.4556 5.26824 12.1952 5.52859L7.99996 9.72386L3.8047 5.52859C3.54435 5.26824 3.12224 5.26824 2.86189 5.52859C2.60154 5.78894 2.60154 6.21105 2.86189 6.4714L7.52855 11.1381Z" fill="#4A5565" />
        </svg>
   
    )
}
